import * as z from 'zod/mini';
import { Id } from '@sigma/common/schema/Id.js';
export const File = z.object({
    id: Id,
    name: z.string(),
    type: z.string(),
    width: z.optional(z.number()),
    height: z.optional(z.number()),
    /** File size in bytes. Optional — not all files have it set. */
    size: z.optional(z.number()),
});
//# sourceMappingURL=File.js.map